import React from 'react';
import './StatusCellRenderer.scss';
export const BusinessStatusCellRenderer = (params: any) => {
    const item = params.data.business_display_status && params.data.business_display_status.split('_').join(" ");
    return (
        < >
        <div className='status_column' > {item} </div>
        </ >
    );
}